/* eslint-env browser */

import React from "react";
import PropTypes from "prop-types";
// import config from 'config';
// import request from 'superagent-bluebird-promise';check
import { getCover } from "util/checkImage";
import { cityFormat } from "util/cityFormat";
import { NavLink } from "react-router-dom";

export default function Favorite(props) {
  const favorite = props.favorite;
  let city = "";
  if (favorite[`addressIT`]) {
    city = cityFormat(favorite[`addressIT`]);
  }
  const { url } = getCover(
    favorite.viewStyleSelected,
    favorite.photo,
    favorite.facebook,
    768
  );
  return (
    <div className="photos-profile-container">
      <div
        className="photos-profile-photo"
        style={{ backgroundImage: `url('${url}` }}
      />
      <div
        style={{
          width: "calc(100% - 20px)",
          display: "inline-block",
          margin: "20px 10px",
          height: "80px"
        }}
      >
        <div className="favorites-profile-restaurant-name">
          <div className="line-clamp line-clamp-2">
            <NavLink
              to={`/restaurant?${favorite.alias}`}
              className="user-menu-link"
              // className={classes.itemLink + " " + classes.userCollapseLinks}
            >
              {favorite.name}
            </NavLink>
            {/* <a
              className="last-reviews-card-name"
              style={{ textDecoration: "none" }}
              href={`/restaurant?${favorite.alias}`}
              title={`${favorite.name}`}
            >
              {favorite.name}
            </a> */}
          </div>
          <div className="photos-profile-restaurant-location">{city}</div>
        </div>
        <div className="favorites-profile-restaurant-heart-container">
          <div>
            <i
              className="icon icon-Preferences-full-24"
              style={
                favorite.isFavorite
                  ? { color: "#e7382f", fontSize: "28px", marginBottom: "-5px" }
                  : { fontSize: "28px", marginBottom: "-5px" }
              }
            />
          </div>
          <div>{favorite.status === "try" ? "da provare" : "da ricordare"}</div>
        </div>
      </div>
    </div>
  );
}

Favorite.propTypes = {
  attributes: PropTypes.object.isRequired,
  favorite: PropTypes.object.isRequired
};
